import { render, staticRenderFns } from "./cart-container.vue?vue&type=template&id=24c6e10d&"
import script from "./cart-container.vue?vue&type=script&lang=js&"
export * from "./cart-container.vue?vue&type=script&lang=js&"
import style0 from "./cart-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports